import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic, Award, Lock, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export function DictionCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/pronunciation/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const pct = Math.min(100, Math.round((s.words_ok / s.target) * 100));

  return (
    <section className="bg-white rounded-2xl border-2 border-slate-200 p-5 space-y-3 rise rise-1" data-testid="diction-card">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-xs font-bold uppercase text-slate-500"><Mic className="w-4 h-4 text-orange-500" /> Prononciation</span>
        <Link to="/prononciation" data-testid="diction-practice-link" className="text-xs font-bold text-orange-600 hover:underline">S'entraîner</Link>
      </div>
      <div className="flex items-center gap-4">
        <div
          data-testid="diction-badge"
          data-earned={s.badge.earned}
          className={`shrink-0 w-16 h-16 rounded-full grid place-items-center ${s.badge.earned ? "bg-sky-500 text-white" : "bg-slate-200 text-slate-500"}`}
        >
          {s.badge.earned ? <Award className="w-8 h-8" /> : <Lock className="w-6 h-6" />}
        </div>
        <div className="flex-1 space-y-1">
          <div className="font-display text-xl font-bold uppercase">Bonne diction</div>
          <div className="h-3 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full bg-sky-500 transition-[width] duration-700" style={{ width: `${pct}%` }} />
          </div>
          <div className="text-xs font-bold text-slate-500" data-testid="diction-progress">{s.words_ok}/{s.target} mots bien prononcés · {s.rate}% de réussite</div>
        </div>
      </div>
      {s.recent.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="diction-history">
          {s.recent.map((r, i) => (
            <span key={`${r.created_at}-${r.word}`} className={`inline-flex items-center gap-1 text-xs font-bold rounded-full px-2 py-1 ${r.ok ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-700"}`}>
              {r.ok ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />} {r.word}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
